import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';
import {ChartsSearchInterface} from '../../../../models/charts-search.interface';
import {ActivatedRoute} from '@angular/router';
import {setFormValuesFromQueryParams} from '../../../../utils/filters-utils';

@Component({
  selector: 'app-vct-from-filter',
  templateUrl: './vct-from-filter.component.html',
  styleUrls: ['./vct-from-filter.component.scss']
})
export class VctFromFilterComponent implements OnInit {

  @Input()
  years!: number[];

  searchForm = this.formBuilder.group({
    year: [''],
    member: [],
    order: ['alph']
  });

  get yearControl(): FormControl {
    return this.searchForm.get('year') as FormControl;
  }

  get memberControl(): FormControl {
    return this.searchForm.get('member') as FormControl;
  }

  get orderControl(): FormControl {
    return this.searchForm.get('order') as FormControl;
  }

  @Output()
  search: EventEmitter<ChartsSearchInterface> = new EventEmitter<ChartsSearchInterface>();

  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    this.yearControl.setValue(this.years[0]);
    this.orderControl.setValue('alph');
    setFormValuesFromQueryParams(this.searchForm, this.activatedRoute);
  }

  handleSubmit(): void {
    const search: ChartsSearchInterface = {
      startYear: this.yearControl.value,
      member: this.memberControl.value,
      order: this.orderControl.value
    };
    this.search.emit(search);
  }

  clean(): void {
    this.yearControl.setValue(this.years[0]);
    this.orderControl.setValue('alph');
    this.memberControl.reset();
    this.search.emit({startYear: this.years[0]});
  }

}
